export function calculateTotalForPercentage(items: Array<ExternalBookingItem>, applyToAllTreatments: boolean, treatmentIds: Maybe<string>[], discountAmount: number) {
  return Math.ceil(items.reduce((a, b) => {
    if (applyToAllTreatments || (b.treatmentId && treatmentIds.includes(b.treatmentId))) {
      const fee = Math.round(Number(b.fee))
      return a + (fee - fee * (discountAmount / 100))
    }
    return a + Math.round(Number(b.fee))
  }, 0))
}